import { render, staticRenderFns } from "./SingleLevelSelector.vue?vue&type=template&id=5a50363a&scoped=true"
import script from "./SingleLevelSelector.vue?vue&type=script&lang=js"
export * from "./SingleLevelSelector.vue?vue&type=script&lang=js"
import style0 from "./SingleLevelSelector.vue?vue&type=style&index=0&id=5a50363a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a50363a",
  null
  
)

export default component.exports